/**
 * Masternodes subpage that is used for `pages/wallet.jsx`.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/subpages/walletintegration.jsx
 * @class WalletIntegration
 * @since 0.0.1
 */

import React from 'react';
import {Ripple} from '@rmwc/ripple';
import {Icon} from '@rmwc/icon';
import logo from '../../images/mew-logo.svg';
import Footer from '../Footer';
import Title from '../Title';
import translations from '../../lib/translations';
import {walletUrl} from '../../lib/constants/external-wallet';

const WalletIntegration = props => {
    const translate = translations.init(props);

    return (
        <div className="wallet-integration pure-u subpage">
            <Title
                subTitle={translate.md('wallet-integration')}
                title={translate.t('WALLET_INTEGRATION')} />
            <section className="wallet-area">
                <div className="wallet-title">
                    <h5>{translate.t('ENERGI_WALLET')}</h5>
                    <span dangerouslySetInnerHTML={{__html: translate.md('mew-description')}} />
                </div>
                <a href={walletUrl} rel="noreferrer noopener" target="_blank">
                    <Ripple className="ripple-wrapper">
                        <div className="energi-mew-btn">
                            <div className="logo-title">
                                <img alt="energi logo" src={logo} />
                            </div>
                            <div className="logo-bottom">
                                <span>{translate.t('VISIT_ENERGI_WALLET', true)}</span>
                                <Icon icon="call_made" />
                            </div>
                        </div>
                    </Ripple>
                </a>
            </section>
            <Footer {...props} />
        </div>
    );
};

export default WalletIntegration;
